/* eslint-disable no-shadow */
import React from 'react';

import { Link } from 'react-router-dom';
import { get } from 'lodash';

import useUserRole from '../../../../../hooks/useUserRole';
import formatResults from './helpers/formatResults';
import createResultString from './helpers/createResultString';

const createResult = (type, result, setModalOpen, isLender) => {
  const formatting = formatResults(result, type, isLender);

  if (!formatting) {
    return null;
  }

  return (
    <>
      <Link
        className="flex items-center p-2 text-slate-800 dark:text-slate-100 hover:text-white hover:bg-indigo-500 rounded group"
        to={formatting.link ? formatting.link(result) : ''}
        onClick={() => setModalOpen(false)}
      >
        <svg
          className="w-4 h-4 fill-current text-slate-400 dark:text-slate-500 group-hover:text-white group-hover:text-opacity-50 shrink-0 mr-3"
          viewBox="0 0 16 16"
        >
          <path d="M14 0H2c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h8l5-5V1c0-.6-.4-1-1-1zM3 2h10v8H9v4H3V2z" />
        </svg>
        {createResultString(result, formatting)}
      </Link>
      {formatting.subParts && (
        <ul>
          {get(result, formatting.subParts.source)?.map((subResult) => (
            <li key={subResult.id}>
              <Link
                className="flex items-center p-2 pl-10 text-slate-600 dark:text-slate-400 hover:text-white hover:bg-indigo-500 rounded group"
                to={
                  formatting.subParts.link
                    ? formatting.subParts.link(subResult)
                    : ''
                }
                onClick={(event) => {
                  event.stopPropagation();
                  setModalOpen(false);
                }}
              >
                {createResultString(subResult, {
                  parts: formatting.subParts.parts,
                })}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default function SearchResult({ setModalOpen, result, type }) {
  // console.log(result, type);

  const { isLender } = useUserRole();

  return <li>{createResult(type, result, setModalOpen, isLender)}</li>;
}
